import {Component, Input, OnInit} from '@angular/core';
import {LineInterface} from '../../../../lines/models/line.interface';
import {select, Store} from '@ngrx/store';
import {UpdateSelectedProcedure} from '../../../store/actions/selected-procedure.actions';
import {UpdateMission} from '../../../store/actions/mission.actions';
import {GetOfferDetails} from '../../../../lines/store/actions/offer-details.actions';
import {ConstsHelper} from '../../../../../helpers/consts.helper';
import {OfferDetailsInterfaceState} from '../../../../lines/store/state/offer-details.state';
import {OfferDetailsInterface} from '../../../models/offer-details.interface';
import {environment} from '../../../../../../environments/environment';
import {MsisdnProcedureInterfaceState} from '../../../../lines/store/state/msisdn-procedure.state';
import {OfferShuntersInterface} from '../../../models/offer-shunters.interface';

@Component({
    selector: 'app-cancel-change-offer',
    templateUrl: './cancel-change-offer.component.html',
    styleUrls: ['./cancel-change-offer.component.css'],
    standalone: false
})
export class CancelChangeOfferComponent implements OnInit {

    @Input()
    line: LineInterface;

    @Input()
    procedureCode: string;

    offerDetails: OfferDetailsInterface = null;
    portabilityDate: string;
    differenceInDays: number;
    environment = environment;
    formSubmitted: boolean;

    constructor(private store: Store<any>) {
    }

    ngOnInit() {
        this.store.pipe(select(ConstsHelper.REDUCER_OFFER_DETAILS)).subscribe((result: OfferDetailsInterfaceState) => {
            if (null != result.offerDetails) {
                this.offerDetails = result.offerDetails;
            }
        });

        this.portabilityDate = null;
        this.differenceInDays = 0;
        this.formSubmitted = false;
        this.store.dispatch(new GetOfferDetails(this.line.offer.id));
        this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_PROCEDURES)).subscribe((response: MsisdnProcedureInterfaceState) => {
            for (const procedure of response.msisdnProcedures) {
                if (procedure.code === this.procedureCode && procedure.lastMessage['data']) {
                    this.portabilityDate = procedure.lastMessage['data']['portability_date'];
                    this.calculateDiffDates();
                }
            }
        });
    }

    cancel() {
        this.store.dispatch(new UpdateSelectedProcedure(''));
    }

    confirmation() {
        if (this.formSubmitted === false) {
            this.formSubmitted = true;
            this.store.dispatch(new UpdateMission(
                {
                    step: 1,
                    phoneNumber: this.line.phoneNumber,
                    confirmation: true,
                    currentOfferId: this.line.offer.id,
                    currentOfferName: this.line.offer.labelTunnel,
                    portabilityDate: this.portabilityDate,
                    differenceInDays: this.differenceInDays,
                },
                this.procedureCode
            ));
        }
    }

    getMonth() {
        const date = this.portabilityDate.split('/');
        const months = {
            '01': 'Janvier',
            '02': 'Février',
            '03': 'Mars',
            '04': 'Avril',
            '05': 'Mai',
            '06': 'Juin',
            '07': 'Juillet',
            '08': 'Août',
            '09': 'Septembre',
            '10': 'Octobre',
            '11': 'Novembre',
            '12': 'Décembre'
        };

        if (date.length === 3) {
            return months[date[1]];
        } else {
            return this.portabilityDate;
        }
    }

    calculateDiffDates() {
        const date = this.portabilityDate.split('/');
        const date1 = new Date(date[1] + '/' + date[0] + '/' + date[2]);
        const date2 = new Date();
        const differenceInTime = date1.getTime() - date2.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        if (differenceInDays > 0) {
            this.differenceInDays = differenceInDays;
        } else {
            this.differenceInDays = 0;
        }
    }

    getShunters(offerDetails: OfferDetailsInterface) {
        const shunters: OfferShuntersInterface = { data: [], prices: [] };
        for (const price of offerDetails.shunters_price) {
            shunters.prices.push(parseFloat((price * 1.2).toFixed(2)));
        }
        for (const data of offerDetails.shunters_data) {
            shunters.data.push((data === 0) ? '0' : (data / 1000000) + 'Go');
        }
        return shunters;
    }
}
